import React, { useState } from "react";
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

const Facts = () => {

  const [counter, setCounter] = useState(false);

  const data = [
    {
      count: 32,
      desc:
        "Certifications",
    },
    {
      count: 81,
      desc:
        "Competencies",
    },
    {
      count: 148,
      desc:
        "Courses",
    }
  ];

  const onVisibilityChange = isVisible => {
    if (isVisible) {
      setCounter(true);
    }
  }

  return (
    <div className="rn-counterup-area pt--25 bg_color--1">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title text-center">
              <h3 className="fontWeight500">My Learnings:</h3>
            </div>
          </div>
        </div>
        <div className="row">
          {data.map((item,i)=>{
            return(
              <div key={item.count+i} className="counterup_style--1 col-lg-4 col-md-4 col-sm-6 col-12 show-on-scroll is-visible">
                <h5 className="counter">
                  <VisibilitySensor onChange={onVisibilityChange} offset={{top:10}} delayedCall>
                    <CountUp end={counter ? item.count : 0} duration={1}/>
                  </VisibilitySensor>
                </h5>
                <p className="description">
                  {item.desc}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
};

export default Facts;
